import { entityValue } from 'app/infrastructure/store/entity';
import { columnName, tableName } from 'app/area/case/case-data-model';
import { Entity } from 'app/types-shared';
import maxBy from 'lodash/maxby';
import minBy from 'lodash/minby';
import isNumber from 'lodash/isnumber';

export const sequence = (connection: Entity) => {
  return Number(entityValue(connection, columnName[tableName.connectedCases].connectedSequence));
};

export const maxSequenceEntity = (connections: Entity[]) => {
  return maxBy(connections, c => sequence(c));
};

export const minSequenceEntity = (connections: Entity[]) => {
  return minBy(connections, c => sequence(c));
};

export const nextSequenceValue = (maxSequence: number) => {
  return (maxSequence && isNumber(maxSequence)) ? maxSequence + 1 : 1;
};

export const updateSequence = <T>(
  entities: T[],
  fromIndex: number,
  steps: number
): T[] => {
  const cloned = [...entities];
  if (!cloned.length || steps === 0) { return cloned }

  const newIndex = Math.max(0, Math.min(cloned.length - 1, fromIndex + steps));
  const [moved] = cloned.splice(fromIndex, 1);
  cloned.splice(newIndex, 0, moved);

  return cloned;
};

export enum SEQUENCE_DIRECTION {
  UP = 'up',
  DOWN = 'down'
}

export const calculateMoveSteps = <T>(
  entities: T[],
  entitySubset: T[],
  currentEntity: T,
  direction: SEQUENCE_DIRECTION
): number => {
  const step = direction === SEQUENCE_DIRECTION.UP ? -1 : 1;
  if (!entities?.length) { return 0 }
  if (!entitySubset?.length) { return step }

  const currentSubsetIndex = entitySubset.indexOf(currentEntity);
  if (currentSubsetIndex === -1) { return 0 }

  const nextSubsetIndex = currentSubsetIndex + step;
  if (nextSubsetIndex < 0 || nextSubsetIndex >= entitySubset.length) { return step }

  const nextEntity = entitySubset[nextSubsetIndex];
  const targetEntityIndex = entities.indexOf(nextEntity);
  const currentEntityIndex = entities.indexOf(currentEntity);
  
  if (currentEntityIndex === -1 || targetEntityIndex === -1) { return step }

  const moveSteps = targetEntityIndex - currentEntityIndex;
  if (moveSteps === 0 || Math.abs(moveSteps) >= entities.length) { return step }

  return moveSteps;
};
